import HorizontalMenuItem from 'common/components/entities/Menu/components/Desktop/Horizontal/components/HorizontalMenuItem'
import HorizontalMenuUi from 'common/components/entities/Menu/components/Desktop/Horizontal/ui/HorizontalMenuUi'
import { MenuItemInterface } from 'common/components/entities/Menu/types/MenuInterface'
import { AlignSelfType, AlignType, PaddingType } from 'common/types/styleTypes'
import { isBlogReplacementPlaceholder } from 'common/utils/blogReplacementsUtils'
import {
  FontProps,
  transformAlignSelfToAlign,
} from 'common/utils/styleUtilsNew'
import React from 'react'

export interface HorizontalMenuProps extends FontProps {
  attrId: string
  items: MenuItemInterface[]
  alignSelf: AlignSelfType
  mobileAlignSelf?: AlignSelfType
  padding?: PaddingType
  mobilePadding?: Partial<PaddingType>
  spacing: number
  mobileSpacing?: number
  subMenuColor?: string
  subMenuBackgroundColor?: string
  subMenuSpacing?: number
  lineHeight?: number
  mobileLineHeight?: number
  activeItemColor: string
  activeSubmenuColor?: string
  mobileActiveItemColor?: string
  itemUnderlineColor?: string
  mobileItemUnderlineColor?: string
  isVisibleOnMobile: boolean
  disablePointerEvents?: boolean
  forceHide?: boolean
  isEditing?: boolean
  textAlign?: AlignType
  mobileTextAlign?: AlignType
}

const HorizontalMenu = (props: HorizontalMenuProps) => {
  const {
    items,
    alignSelf,
    mobileAlignSelf,
    attrId,
    disablePointerEvents,
    padding,
    mobilePadding,
    isVisibleOnMobile,
    forceHide,
  } = props
  const textAlign = transformAlignSelfToAlign(alignSelf)
  return (
    <HorizontalMenuUi
      alignSelf={alignSelf}
      mobileAlignSelf={mobileAlignSelf}
      id={attrId}
      disablePointerEvents={disablePointerEvents}
      padding={padding}
      mobilePadding={mobilePadding}
      isVisibleOnMobile={isVisibleOnMobile}
      forceHide={forceHide}
    >
      {items
        .filter(item => !isBlogReplacementPlaceholder(item.link))
        .map((item, index) => (
          <HorizontalMenuItem
            key={`${attrId}-horizontal-item-${index}-${item.link || item.text}`}
            item={item}
            textAlign={textAlign}
            index={index}
            {...props}
          />
        ))}
    </HorizontalMenuUi>
  )
}

export default HorizontalMenu
